// src/layouts/LaamLayout.js
import { Outlet } from "react-router-dom";
import LaamTopNav from "./LaamTopNav";

const LaamLayout = () => {
  return (
    <div className="laam-module">
      <LaamTopNav />
      <div className="laam-content">
        <Outlet />
      </div>
    </div>
  );
};

export default LaamLayout;
